import React from 'react';
import PropTypes from 'prop-types';
import BasicPortlet from '../../../../commonComponents/portlets/BasicPortlet';
import translate from '../../../../commonComponents/translate';
import CertificateProp from '../../../academy/propTypes/certificateProp';
import Anchor from '../../../../commonComponents/Anchor';

function CertificatePortlet({ t, certificates }) {
  const whatKindOfCertificate = c => {
    if (c && c.course) {
      return c.course.name;
    } if (c && c.session) {
      return c.session.name;
    } if (c && c.journey) {
      return c.journey.title;
    }
    return '';
  };
  return (
    <div className="row">
      <div className="col-12">
        <BasicPortlet title={t('profile_certificates')}>
          <div className="row">
            {certificates.map(c => (
              <div className="profile-certificate col-md-3" key={c._id}>
                <Anchor href={`/certificate/${c._id}`}>
                  <div className="certificate-name">{whatKindOfCertificate(c)}</div>
                  <div className="profile-certificate-body">
                    {c.isLocked && (
                      <div className="profile-lock-overlay">
                        <span className="profile-unlock">{t('unlock')}</span>
                      </div>
                    )}
                    {c?.image?.thumb ? (
                      <img
                        className="certificate-thumb"
                        src={c.image.thumb}
                        alt="certificate thumbnail"
                      />
                    ) : (
                      <div className="certificate-body">
                        <div className="certificate-img">
                          <div className="certificatePortlet-noCertificate">
                            <img
                              className="certificate-thumb"
                              alt="certificate preview"
                              src="/images/academy/certificate/certificate.png"
                            />
                            <button
                              type="button"
                              className="certificate-overlay-button"
                              onClick={() => {}}
                            >
                              <img
                                alt="refresh arrow"
                                src="/images/academy/certificate/load.svg"
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="certificate-hours">
                    {c.duration
                      ? `${Math.round(c.duration / (1000 * 60 * 60))}h`
                      : '- -'}
                  </div>
                </Anchor>
              </div>
            ))}
          </div>
        </BasicPortlet>
      </div>
    </div>
  );
}

CertificatePortlet.propTypes = {
  t: PropTypes.func.isRequired,
  certificates: PropTypes.arrayOf(PropTypes.shape(CertificateProp.propType))
    .isRequired,
};

export default translate(CertificatePortlet);
